var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8126 21.6667C56.552 21.6667 59.5834 18.6353 59.5834 14.8958C59.5834 11.1564 56.552 8.125 52.8126 8.125C49.0732 8.125 46.0417 11.1564 46.0417 14.8958C46.0417 18.6353 49.0732 21.6667 52.8126 21.6667Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8126 21.6667C56.552 21.6667 59.5834 18.6353 59.5834 14.8958C59.5834 11.1564 56.552 8.125 52.8126 8.125C49.0732 8.125 46.0417 11.1564 46.0417 14.8958C46.0417 18.6353 49.0732 21.6667 52.8126 21.6667Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M56.1168 25.2146C57.823 24.6729 59.5834 26 59.5834 27.8146V42.0062C59.5834 51.4854 54.1668 55.5479 46.0418 55.5479H18.9584C10.8334 55.5479 5.41675 51.4854 5.41675 42.0062V23.0479C5.41675 13.5687 10.8334 9.50623 18.9584 9.50623H39.5688C41.3292 9.50623 42.5209 11.1313 42.1959 12.8375C41.8709 14.4354 41.9251 16.1417 42.4126 17.9021C43.4147 21.5312 46.3667 24.4291 49.9959 25.3771C52.1355 25.9187 54.2209 25.8104 56.1168 25.2146Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 34.8562C30.2249 34.8562 27.9229 34.1521 26.1624 32.7167L17.6853 25.9458C16.8187 25.2417 16.6562 23.9688 17.3604 23.1021C18.0645 22.2354 19.3374 22.0729 20.2041 22.7771L28.6812 29.5479C30.7395 31.2 34.2332 31.2 36.2916 29.5479L39.4874 27.0021C40.3541 26.2979 41.6541 26.4333 42.3312 27.3271C43.0354 28.1937 42.9 29.4938 42.0062 30.1708L38.8103 32.7167C37.077 34.1521 34.7749 34.8562 32.4999 34.8562Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNotification);
export default __webpack_public_path__ + "static/media/sms-notification.b402eb5c9e93c02602c1e083b5ca7559.svg";
export { ForwardRef as ReactComponent };